export default __webpack_public_path__ + "static/carousel-homepage-4-7b8e975688d361cb4b0bd990b7acc239.jpg";